var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundcloudLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,11c-3.60156,0 -7,1.78906 -9,4.6875v3.5l0.3125,0.21875l0.375,-1c1.39844,-3.30078 4.71875,-5.40625 8.21875,-5.40625c5,0 9,4 9,9v2l1.5,-0.59375c0.69922,-0.30078 1.39453,-0.40625 2.09375,-0.40625c3,0 5.5,2.5 5.5,5.5c0,3 -2.5,5.5 -5.5,5.5h-21.5v2h21.5c4.10156,0 7.5,-3.39844 7.5,-7.5c0,-4.10156 -3.39844,-7.5 -7.5,-7.5c-0.5,0 -1,0.08594 -1.5,0.1875c-0.5,-5.69922 -5.19922,-10.1875 -11,-10.1875zM17,16c-0.69922,0 -1.39844,0.08594 -2,0.1875v19.8125h2zM18,16v20h2v-19.5c-0.60156,-0.19922 -1.30078,-0.39844 -2,-0.5zM14,16.5c-0.69922,0.30078 -1.39844,0.60156 -2,1v18.5h2zM11,18.3125c-0.80078,0.69922 -1.5,1.59375 -2,2.59375v15.09375h2zM6.5,22c-0.17578,0.01172 -0.35156,0.04297 -0.5,0.09375v13.8125c0.30078,0.10156 0.69922,0.09375 1,0.09375h1v-13.90625c-0.30078,-0.10156 -0.69922,-0.09375 -1,-0.09375c-0.14844,0 -0.32422,-0.01172 -0.5,0zM5,22.3125c-0.69922,0.19922 -1.39844,0.5 -2,1v11.375c0.60156,0.39844 1.30078,0.80078 2,1zM2,24.09375c-1.19922,1.30078 -2,3.00781 -2,4.90625c0,1.89844 0.80078,3.60547 2,4.90625z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundcloudLight);
export default __webpack_public_path__ + "static/media/soundcloud-light.d912d0841868ebcb030c62dbed4e1e74.svg";
export { ForwardRef as ReactComponent };